/**
 * MyRosterByAgeChart export with lazy loading
 *
 * Lazy loads the Victory-based bar chart to reduce initial bundle size.
 */

/* eslint-disable component-structure/enforce-component-structure -- Intentional lazy wrapper pattern */
import React, { ComponentProps, lazy, memo, Suspense } from "react";

import ChartSkeleton from "@/components/molecules/ChartSkeleton";

const MyRosterByAgeChartContainer = lazy(
  () => import("./MyRosterByAgeChartContainer")
);

/** Props for the lazy-loaded MyRosterByAgeChart component */
type MyRosterByAgeChartProps = ComponentProps<
  typeof MyRosterByAgeChartContainer
>;

/**
 * Lazy-loaded MyRosterByAgeChart wrapper with loading fallback.
 * @param props - MyRosterByAgeChartContainer props
 */
const LazyMyRosterByAgeChart = memo((props: MyRosterByAgeChartProps) => (
  <Suspense fallback={<ChartSkeleton />}>
    <MyRosterByAgeChartContainer {...props} />
  </Suspense>
));

LazyMyRosterByAgeChart.displayName = "LazyMyRosterByAgeChart";

export default LazyMyRosterByAgeChart;
/* eslint-enable component-structure/enforce-component-structure -- Re-enable after lazy wrapper */
